import { createContext } from "react";

const QuestionContext = createContext({
  handleChangeTraslation: undefined,
  getDataIdiom: undefined,
});

export default QuestionContext;
